import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HomeNav from './HomeNav';
import Footer from './Components/Footer/Footer';
import RoundedButton from '../../Components/RoundedButton/RoundedButton';
import HelpOfferSection from './Components/HelpOfferSection';
import SpiderWebSection from './Components/SpiderWebSection';
import BannerSection from './Components/BannerSection';
import Background, { BackgroundElement } from './Components/Background';
import { OpenDemoLink } from '../../Components/Utilities/HelperFunctions';

// Media
import SwirlyLines2 from '../../Images/Home/swirly_lines_2.png';
// import SwarmWave from '../../Images/Home/swarm_wave.png';
import HelpOffer3 from '../../Images/Home/help_offer_3.png';
import AdviceProduct from '../../Images/Home/product_score.png';
import AdviceWeb from '../../Images/Home/xpektor_web_advice.png';

export default function Advice() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="xpektor-home">
      <div className="other-intro advice-intro">
        <HomeNav />
        <div className="section intro-section">
          <p className="section-title">
            {t('advice-page.intro-section.section-title')}
          </p>
          <h1>{t('advice-page.intro-section.header')}</h1>
          <div className="button-row">
            <RoundedButton
              text={t('shared.read-more')}
              fillCyan
              onClick={() => {
                history.push('/why');
              }}
            />
            <RoundedButton
              text={t('shared.book-demo')}
              onClick={OpenDemoLink}
            />
          </div>
        </div>
      </div>
      <Background color1="#000b4f">
        <div className="intro-row-section advice-intro-row">
          <h3>{t('advice-page.intro-row-section.header')}</h3>
        </div>
      </Background>
      <Background color1="#0316F3">
        <div className="section post-intro-section">
          <h1>Ligg steget före</h1>
          <div className="post-intro-content">
            <div className="image-column">
              <img src={AdviceProduct} alt="product_image" />
            </div>
            <div className="text-column">
              <h3>{t('advice-page.post-intro-content.header')}</h3>
              <p className="section-text">
                <i>
                  {t('advice-page.post-intro-content.quote-parts.description')}
                  <br />
                  <br />
                  {t('advice-page.post-intro-content.quote-parts.points.0')}
                  <br />
                  {t('advice-page.post-intro-content.quote-parts.points.1')}
                  <br />
                  {t('advice-page.post-intro-content.quote-parts.points.2')}
                  <br />
                  {t('advice-page.post-intro-content.quote-parts.points.3')}
                </i>
                <br />
                <br />
                <p
                  className="section-text"
                  style={{ width: '100%', textAlign: 'right' }}
                >
                  - {t('advice-page.post-intro-content.quotee')}
                </p>
              </p>
              <RoundedButton
                text={t('shared.book-demo')}
                fillCyan
                onClick={OpenDemoLink}
              />
            </div>
          </div>
        </div>
      </Background>
      <Background color1="#000B4F" color2="#010024">
        <HelpOfferSection
          image={HelpOffer3}
          pTitle={t('shared.help-offer-section.p-title')}
          title={t('shared.help-offer-section.advice-title')}
          points={[
            ...t('shared.help-offer-section.advice-points', {
              returnObjects: true,
            }),
          ]}
          btnText={t('shared.book-demo')}
        />
        <div className="section-with-element">
          <SpiderWebSection
            pTitle={t('shared.spider-web-section.p-title')}
            title={t('shared.spider-web-section.alt-title')}
            text={t('shared.spider-web-section.advice-text')}
            btnText={t('shared.read-more')}
            image={AdviceWeb}
          />
          <BackgroundElement img={SwirlyLines2} yPos={-400} />
        </div>
      </Background>
      <Background end>
        <BannerSection />
        <Footer darkMode />
      </Background>
    </div>
  );
}
